import { render, staticRenderFns } from "./publish-product-done.vue?vue&type=template&id=04baa319&scoped=true&"
import script from "./publish-product-done.vue?vue&type=script&lang=js&"
export * from "./publish-product-done.vue?vue&type=script&lang=js&"
import style0 from "./publish-product-done.vue?vue&type=style&index=0&id=04baa319&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04baa319",
  null
  
)

export default component.exports